export interface CustomEmbedData {
  html: string;
  css: string;
  javascript: string;
}

export interface VideoEmbedData {
  platform: string;
  videoId: string;
  autoplay: boolean;
  muted: boolean;
  controls: boolean;
  loop: boolean;
  aspectRatio: string;
  width: string;
  height: string;
}

export interface IframeEmbedData {
  src: string;
  title: string;
  width: string;
  height: string;
  allowFullscreen: boolean;
  frameBorder: boolean;
  allow: string;
}

export interface ContainerStyle {
  padding: string;
  margin: string;
  maxWidth: string;
  backgroundColor: string;
  borderRadius: string;
  boxShadow: string;
}

export interface HtmlEmbedFormData {
  embedType: string;
  custom: CustomEmbedData;
  video: VideoEmbedData;
  iframe: IframeEmbedData;
  responsive: boolean;
  lazyLoad: boolean;
  containerStyle: ContainerStyle;
}

export interface HtmlEmbedEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  initialData?: any;
  isLoading?: boolean;
}

export type EmbedTab = 'custom' | 'video' | 'iframe';

export const DEFAULT_CUSTOM_EMBED: CustomEmbedData = {
  html: '',
  css: '',
  javascript: '',
};

export const DEFAULT_VIDEO_EMBED: VideoEmbedData = {
  platform: 'youtube',
  videoId: '',
  autoplay: false,
  muted: false,
  controls: true,
  loop: false,
  aspectRatio: '16:9',
  width: '560',
  height: '315',
};

export const DEFAULT_IFRAME_EMBED: IframeEmbedData = {
  src: '',
  title: 'Embedded content',
  width: '100%',
  height: '400',
  allowFullscreen: true,
  frameBorder: false,
  allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
};

export const DEFAULT_CONTAINER_STYLE: ContainerStyle = {
  padding: '',
  margin: '',
  maxWidth: '',
  backgroundColor: '',
  borderRadius: '',
  boxShadow: '',
};

export const DEFAULT_FORM_DATA: HtmlEmbedFormData = {
  embedType: 'custom',
  custom: DEFAULT_CUSTOM_EMBED,
  video: DEFAULT_VIDEO_EMBED,
  iframe: DEFAULT_IFRAME_EMBED,
  responsive: true,
  lazyLoad: false,
  containerStyle: DEFAULT_CONTAINER_STYLE,
};
